var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?_c('div',[(_vm.student)?_c('div',[_c('nav-bar'),_c('router-view')],1):_c('div',[_c('login-page')],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }